<template>
  <div>
    <div class="card-body">
      <div class="tab-content">
        <div class="tab-pane active" id="activity">
          <div class="row">
            <div class="col-md-12">
              <h5 class="h4-t">Appointment History</h5>
              <hr />
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead class="bg-info">
                    <tr>
                      <th>Contract Type</th>
                      <th>Department</th>
                      <th>Office</th>
                      <th>Job Title</th>
                      <th>Status</th>
                      <th style="width: 10px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in appointments">
                      <td>{{item._Contract}}</td>
                      <td>{{item._EducationalDepartment}}</td>
                      <td>{{item._Department}}</td>
                      <td>{{item._Designation}}</td>
                      <td>{{item._Status}}</td>
                      <td style="white-space: nowrap">
                        <button class="btn btn-sm btn-info" v-on:click="showAppointmentModal(item, ind)"><i class="fas fa-edit"></i></button>
                        <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteAppointment" v-on:click="appointmentIndex = ind;"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showAppointmentModal()">Add New</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.tab-content -->
    </div>
    <div class="card-footer">
      <a class="btn btn-primary" href="../Employees/List">Back to List</a>
      <div class="float-right">
        <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
        <!--<input type="submit" value="Save Profile" class="btn btn-success  " />-->
      </div>
    </div>
    <div class="modal fade" id="modalAppointment">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Appointments</h4>
          </div>
          <form id="contact" v-on:submit="saveAppointment">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Contract *</label>
                    <select class="form-control" v-model="appointment.ContractID" required>
                      <option value="">--Select--</option>
                      <option v-for="item in contracts" :value="item.ContractID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Job Title *</label>
                    <select class="form-control" v-model="appointment.DesignationID" required>
                      <option value="">--Select--</option>
                      <option v-for="item in designations" :value="item.DesignationID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Type *</label>
                    <select class="form-control" v-model="appointment.EmployeeType" required>
                      <option value="">--Select--</option>
                      <option value="0">Faculty</option>
                      <option value="1">Staff</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Department</label>
                    <select class="form-control" v-model="appointment.EducationalDepartmentID">
                      <option value="0">--Select--</option>
                      <option v-for="item in educationalDepartments" :value="item.School_DepartmentsID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Office</label>
                    <select class="form-control" v-model="appointment.DepartmentID">
                      <option value="0">--Select--</option>
                      <option v-for="item in departments" :value="item.DepartmentID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Sub Department</label>
                    <select class="form-control" v-model="appointment.SubDepartmentID">
                      <option value="0">--Select--</option>
                      <option v-for="item in subDepartments" :value="item.SubDepartmentID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Status</label>
                    <select class="form-control" v-model="appointment.StatusID" required>
                      <option value="">--Select--</option>
                      <option v-for="item in statuses" :value="item.StatusID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>From Date (Joining Date)</label>
                    <input type="date" class="form-control" v-model="appointment.JoiningDate" required />
                  </div>
                </div>
                <div class="col-md-4" v-if="appointment.StatusID > 1">
                  <div class="form-group">
                    <label>To Date</label>
                    <input type="date" class="form-control" v-model="appointment.LeavingDate" required />
                  </div>
                </div>
                <div class="col-md-4" v-if="appointment.StatusID > 1">
                  <div class="form-group">
                    <label>Releaving Date</label>
                    <input type="date" class="form-control" v-model="appointment.LeavingDate" required />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Job Description</label>
                    <textarea class="form-control" v-model="appointment.JobDescription" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Remarks</label>
                    <textarea class="form-control" v-model="appointment.Remarks" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modalDeleteAppointment">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <h3>Are you sure you want to delete this record ?</h3>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" v-on:click="deleteContact()" class="btn btn-danger">Delete</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>
</template>

<script>

  $(document).ready(function () {
    $('[data-mask]').inputmask()
  });

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        appointments: [],
        appointment: {
          EmployeeAppointmentID: "",
          EmployeeID: '',
          DepartmentID: '',
          EducationalDepartmentID: '',
          SubDepartmentID: '',
          ContractID: '',
          DesignationID: '',
          EmployeeType: '',
          StatusID: 1,
          HiringDate: '',
          JoiningDate: '',
          LeavingDate: '',
          ReleavingDate: '',
          JobDescription: '',
          Remarks: ''
        },
        appointmentIndex: -1,

        departments: [],
        educationalDepartments: [],
        subDepartments: [],
        designations: [],
        contracts: [],
        statuses: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/EmployeesApi/pageLoadAppointment?id=' + vm.employeeId)
          .then(function (res) {
            endReq();

            vm.departments = res.data.departments;
            vm.educationalDepartments = res.data.educationalDepartments;
            vm.subDepartments = res.data.subDepartments;
            vm.designations = res.data.designations;
            vm.contracts = res.data.contracts;
            vm.statuses = res.data.statuses;

            if (res.data.appointments)
              vm.appointments = res.data.appointments;

          })
          .catch(function (error) {
            console.log(error);
          });
      },

      showAppointmentModal(data, index) {
        if (data) {
          this.appointment = Object.assign({}, data);
          this.appointmentIndex = index
        }
        else {
          this.appointment = {
            EmployeeAppointmentID: "",
            EmployeeID: '',
            DepartmentID: '',
            EducationalDepartmentID: '',
            SubDepartmentID: '',
            ContractID: '',
            DesignationID: '',
            EmployeeType: '',
            StatusID: 1,
            HiringDate: '',
            JoiningDate: '',
            LeavingDate: '',
            ReleavingDate: '',
            JobDescription: '',
            Remarks: ''
          };
          this.appointmentIndex = -1;
        }


        $('#modalAppointment').modal('show');
      },

      saveAppointment(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/saveAppointment?id=' + vm.employeeId, {
          appointment: vm.appointment
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              if (vm.appointmentIndex == -1)
                vm.appointments.push(res.data.appointment);
              else {
                vm.appointments[vm.appointmentIndex] = res.data.appointment;
                vm.appointmentIndex = -1;
                $('#modalAppointment').modal('hide');
              }

              vm.appointment = {
                EmployeeAppointmentID: "",
                EmployeeID: '',
                DepartmentID: '',
                EducationalDepartmentID: '',
                SubDepartmentID: '',
                ContractID: '',
                DesignationID: '',
                EmployeeType: '',
                StatusID: 1,
                HiringDate: '',
                JoiningDate: '',
                LeavingDate: '',
                ReleavingDate: '',
                JobDescription: '',
                Remarks: ''
              };
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                toastr.error(`${value}`);
              }
            }
          })
      },

      deleteAppointment() {
        var vm = this;
        startReq();
        axios.get('/api/EmployeesApi/deleteAppointment?id=' + vm.appointments[vm.appointmentIndex].EmployeeAppointmentID)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Deleted Successfully", "Done!");
              vm.appointments.splice(vm.appointmentIndex, 1);
              vm.appointmentIndex = -1;
              $('#modalDeleteAppointment').modal('hide');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      clear() {
        location.reload();
      }

    }
  })
</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/employeeAppointment.vue